<template>
  <div class="hsHeader w100pc fixed">
    <div class="headerTitle">{{ pageName }}</div>
    <div class="shipInquiry" @click="JumpshipInquiry">船只查询</div>
    <div class="search">
      <van-search
        v-model="value"
        shape="round"
        background="#fff"
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @clear="onSearch"
        show-action
      >
        <template #action>
          <div class="searchSlot" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <ul class="flex jc-sa tabs menuList">
      <li
        :class="['menuItem', , activeIndex === index ? 'active' : '']"
        v-for="(menu, index) in menuList"
        :key="`${menu.component}${index}`"
      >
        <div
          :to="menu.component"
          :class="['f20']"
          @click="goItem(menu.component, index)"
        >
          <img
            class="menuImg"
            :src="activeIndex === index ? menu.icon_active : menu.icon"
          />
          <p class="mt-5 f12 text">{{ menu.text }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import bidFail from "../assets/accountant/bidFail.png";
import bidFailActive from "../assets/accountant/bidFailActive.png";
import bidWin from "../assets/accountant/bidWin.png";
import bidWinActive from "../assets/accountant/bidWinActive.png";

import rea from "../assets/accountant/rea.png";
import reaActive from "../assets/accountant/reaActive.png";
import rea1 from "../assets/accountant/rea1.png";
import reaActive1 from "../assets/accountant/reaActive1.png";

import publish from "../assets/dispatch/publish.png";
import publishActive from "../assets/dispatch/publish_active.png";
import unPublish from "../assets/dispatch/unPublish.png";
import unPublishActive from "../assets/dispatch/unPublish_active.png";

import wei from "../assets/audit/wei.png";
import wei_active from "../assets/audit/wei_active.png";
import bohui from "../assets/audit/bohui.png";
import bohui_active from "../assets/audit/bohui_active.png";
import tongguo from "../assets/audit/tongguo.png";
import tongguo_active from "../assets/audit/tongguo_active.png";

import all from "../assets/workOrder/all.png";
import all_active from "../assets/workOrder/all_active.png";

import incomplete from "../assets/workOrder/incomplete.png";
import incomplete_active from "../assets/workOrder/incomplete_active.png";

import reciveOrder from "../assets/workOrder/reciveOrder.png";
import reciveOrder_active from "../assets/workOrder/reciveOrder_active.png";
import overOrder from "../assets/workOrder/overOrder.png";
import overOrder_active from "../assets/workOrder/overOrder_active.png";

export default {
  name: "hsHeader",
  props: {
    keyWords: String,
    component: String,
    pageName: String,
    menuName: String,
  },
  data() {
    return {
      value: "",
      menuLAllist: {
        dispatchPublish: [
          {
            component: "unPublish",
            icon: unPublish,
            icon_active: unPublishActive,
            text: "未发布",
          },
          {
            component: "publish",
            icon: publish,
            icon_active: publishActive,
            text: "已发布",
          },
        ],
        dispatchOrder: [
          {
            component: "dispatchUnreciveOrder",
            icon: unPublish,
            icon_active: unPublishActive,
            text: "未接单",
          },
          {
            component: "dispatchReciveOrder",
            icon: publish,
            icon_active: publishActive,
            text: "已接单",
          },
        ],
        palletBusiness: [
          {
            component: "bidFail",
            icon: bidFail,
            icon_active: bidFailActive,
            text: "未中标",
          },
          {
            component: "bidWin",
            icon: bidWin,
            icon_active: bidWinActive,
            text: "已中标",
          },
        ],

        workOrder: [
          {
            component: "workList1",
            icon: all,
            icon_active: all_active,
            text: "全部工单",
          },
          {
            component: "workList4",
            icon: incomplete,
            icon_active: incomplete_active,
            text: "未接工单",
          },
          {
            component: "workList2",
            icon: reciveOrder,
            icon_active: reciveOrder_active,
            text: "已接工单",
          },
          {
            component: "workList3",
            icon: overOrder,
            icon_active: overOrder_active,
            text: "完成工单",
          },
        ],
        audit: [
          {
            component: "workList1",
            icon: wei,
            icon_active: wei_active,
            text: "未审核",
          },
          {
            component: "workList2",
            icon: bohui,
            icon_active: bohui_active,
            text: "审核驳回",
          },
          {
            component: "workList3",
            icon: tongguo,
            icon_active: tongguo_active,
            text: "已审核",
          },
        ],
        rea: [
          {
            component: "rea",
            icon: rea,
            icon_active: reaActive,
            text: "未发布",
          },
          {
            component: "reaWin",
            icon: rea1,
            icon_active: reaActive1,
            text: "已发布",
          },
        ],
      },
      currentRole: localStorage.getItem("role"),
      activeIndex: 0,
    };
  },
  watch: {
    component(val) {
      // console.log(val)
    },
  },
  computed: {
    menuList() {
      console.log(
        this.compoment
          ? this.compoment
          : this.menuLAllist[this.menuName][0].component
      );
      this.$emit(
        "update:component",
        this.compoment
          ? this.compoment
          : this.menuLAllist[this.menuName][0].component
      );
      return this.menuLAllist[this.menuName];
    },
  },
  methods: {
    JumpshipInquiry() {
      this.$router.push({
        path: "/shipInquiry",
      });
    },
    onSearch() {
      this.$emit("update:keyWord", this.value);
    },
    goItem(path, index) {
      this.activeIndex = index;
      this.value = "";
      this.$emit("update:keyWord", "");
      this.$emit("update:component", path);
    },
  },
  mounted() {
    if (localStorage.getItem("path") === "workList3") {
      this.activeIndex = 2;
      this.$emit("update:component", "workList3");
      localStorage.removeItem("path");
    }
  },
};
</script>

<style lang="less" scope>
.hsHeader {
  background-color: #44b1f9;
  height: 210px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 15px;
  z-index: 3;
  .headerTitle {
    font-size: 16px;
    text-align: center;
    line-height: 25px;
    margin-bottom: 15px;
    height: 25px;
    color: #fff;
  }
  .shipInquiry {
    position: absolute;
    right: 15px;
    top: 15px;
    border-radius: 4px;
    background-color: #0a27f9;
    color: #fff;
    padding: 6px 10px;
    font-size: 12px;
  }
  .search {
    background-color: #44b1f9;
    padding: 0 15px;
    margin-bottom: 17px;
  }
  .tabs {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
  .menuItem {
    width: 90px;
    height: 100px;
    // background-color: rgba(0,0,0,);
    padding-top: 10px;
    border-radius: 5px;
    position: relative;
    &.active {
      background-color: rgba(255, 255, 255, 0.5);
      &::after {
        content: "";
        display: block;
        width: 40px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -20px;
        background-color: #fff;
      }
    }
    .menuImg {
      width: 47px;
      height: 47px;
      display: block;
      margin: 0 auto 15px;
    }
    .text {
      font-size: 13px;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.hsHeader {
  .van-search {
    padding: 0;
    padding-right: 3px;
    border-radius: 15px;
  }
  .van-search__action {
    width: 65px;
    height: 28px;
    background: #44b1f9;
    border-radius: 28px;
    text-align: center;
    line-height: 28px;
    color: #fff;
    padding: 0;
  }
}
</style>